"use strict";
/**
 * 价格竞猜卡片渲染侧接口封装
 * - 获取竞猜记录：GET guess-list
 * - 新增/修改竞猜：POST guess-upsert
 *
 * 说明：通过 fego-render 的 commonApi 调用 server 侧接口
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWatchList = addWatchList;
exports.fetchGuessList = fetchGuessList;
exports.fetchGuessStats = fetchGuessStats;
exports.removeWatchList = removeWatchList;
exports.upsertGuessRecord = upsertGuessRecord;
const { request } = require('@futuweb/fego-render').common;
const commonApi = request.bindCommonApi('common-price-guess');
/**
 * 获取某活动下所有竞猜场次 + 当前用户在这些场次下的记录
 */
async function fetchGuessList(params) {
    return await commonApi.get('guess-list', {
        actSign: params.actSign,
    });
}
/**
 * 获取参与统计（独立接口）
 */
async function fetchGuessStats(params) {
    // 说明：使用 POST 传递批量 sessionId + 当前价，避免服务端再拉行情
    return await commonApi.post('guess-stats', {
        actSign: params.actSign,
        sessions: params.sessions || [],
    });
}
/**
 * 新增/修改竞猜记录
 * @param payload 由前端传递的竞猜参数（type 由服务端根据 sessionId 的配置确定）
 */
async function upsertGuessRecord(payload) {
    return await commonApi.post('guess-upsert', Object.assign({}, payload));
}
/**
 * 添加自选
 */
async function addWatchList(stockId) {
    return await commonApi.post('add-watch-list', {
        stockId,
    });
}
/**
 * 删除自选
 */
async function removeWatchList(stockId) {
    return await commonApi.post('remove-watch-list', {
        stockId,
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7O0FBK0RNLG9DQUFZO0FBQUUsd0NBQWM7QUFBRSwwQ0FBZTtBQUFFLDBDQUFlO0FBQUUsOENBQWlCO0FBMUQxRixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUMsTUFBTSxDQUFDO0FBQzNELE1BQU0sU0FBUyxHQUFHLE9BQU8sQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsQ0FBQztBQUc5RDs7R0FFRztBQUNILEtBQUssVUFBVSxjQUFjLENBQUMsTUFBMkI7SUFDckQsT0FBTyxNQUFNLFNBQVMsQ0FBQyxHQUFHLENBQUMsWUFBWSxFQUFFO1FBQ3JDLE9BQU8sRUFBRSxNQUFNLENBQUMsT0FBTztLQUMxQixDQUFDLENBQUM7QUFDUCxDQUFDO0FBRUQ7O0dBRUc7QUFDSCxLQUFLLFVBQVUsZUFBZSxDQUFDLE1BQTBGO0lBQ3JILDRDQUE0QztJQUM1QyxPQUFPLE1BQU0sU0FBUyxDQUFDLElBQUksQ0FBQyxhQUFhLEVBQUU7UUFDdkMsT0FBTyxFQUFFLE1BQU0sQ0FBQyxPQUFPO1FBQ3ZCLFFBQVEsRUFBRSxNQUFNLENBQUMsUUFBUSxJQUFJLEVBQUU7S0FDbEMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQztBQUVEOzs7R0FHRztBQUNILEtBQUssVUFBVSxpQkFBaUIsQ0FBQyxPQU1oQztJQUNHLE9BQU8sTUFBTSxTQUFTLENBQUMsSUFBSSxDQUFDLGNBQWMsb0JBQ25DLE9BQU8sRUFDWixDQUFDO0FBQ1AsQ0FBQztBQUVEOztHQUVHO0FBQ0gsS0FBSyxVQUFVLFlBQVksQ0FBQyxPQUFlO0lBQ3ZDLE9BQU8sTUFBTSxTQUFTLENBQUMsSUFBSSxDQUFDLGdCQUFnQixFQUFFO1FBQzFDLE9BQU87S0FDVixDQUFDLENBQUM7QUFDUCxDQUFDO0FBRUQ7O0dBRUc7QUFDSCxLQUFLLFVBQVUsZUFBZSxDQUFDLE9BQWU7SUFDMUMsT0FBTyxNQUFNLFNBQVMsQ0FBQyxJQUFJLENBQUMsbUJBQW1CLEVBQUU7UUFDN0MsT0FBTztLQUNWLENBQUMsQ0FBQztBQUNQLENBQUMifQ==